/* global process */

let orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST

export const queryReturnOrderEvaluationTableApi = params => {
  return axios.post(`${orderAuditBase}/admin/return-order-eval/query`, params)
}

export const queryReturnOrderEvalEvaluatorOptionsApi = params => {
  return axios.get(`${orderAuditBase}/admin/return-order-eval/evaluator-options`, { params })
}

export const queryReturnOrderEvalReturnAdminOptionsApi = params => {
  return axios.get(`${orderAuditBase}/admin/return-order-eval/return-admin-options`, { params })
}




// WEBPACK FOOTER //
// ./src/views/audit-task-setting/return-order-evaluation.api.js